<template>
    <div class="notes-container">
      <img class="note" v-for="note in notes" :key="note.id" :src="note.svg" :style="{ top: note.top + 'px', left: note.left + 'px' }" />
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  
  export default {
    setup() {
      const notes = ref([]);
  
      // Fonction pour générer une note de musique aléatoire
      function getRandomNote() {
        const notesList = [
        require('@/assets/music_1.png'),
        require('@/assets/music_2.png'),
        require('@/assets/music_3.png')
      ];
        const randomIndex = Math.floor(Math.random() * notesList.length);
        return notesList[randomIndex];
      }
  
      // Fonction pour ajouter une nouvelle note à l'écran
      function addNote() {
        const note = {
          id: Date.now(),
          top: Math.floor(Math.random() * (window.innerHeight - 50)),
          left: Math.floor(Math.random() * (window.innerWidth - 50)),
          svg: getRandomNote(),
          speed: Math.floor(Math.random() * 10) + 5 // Vitesse aléatoire entre 5 et 15 pixels par seconde
        };
        notes.value.push(note);
        // Supprime la note de l'écran après 5 secondes
        setTimeout(() => {
          const index = notes.value.findIndex(item => item.id === note.id);
          notes.value.splice(index, 1);
        }, 5000);
      }
  
      // Ajoute une nouvelle note toutes les 500 millisecondes
      onMounted(() => {
        var intervalId = setInterval(() => {
        addNote();
      }, 500);
      setTimeout(() => {
        clearInterval(intervalId);
      }, 5000);
      });
  
      return {
        notes
      };
    }
  };
  </script>
  
  <style scoped>
  .note {
    position: absolute;
    width: 30px;
    height: 30px;
    animation: note-float 5s linear;
    z-index: 9999;
  }
  
  @keyframes note-float {
    0% {
      transform: translateY(0) rotate(0);
      opacity: 1;
    }
    50% {
      transform: translateY(-100px) rotate(180deg);
      opacity: 0.5;
    }
    100% {
      transform: translateY(-200px) rotate(360deg);
      opacity: 0;
    }
  }
  </style>
  